import styled from '@emotion/styled'

export const PageWrapper = styled.div`
  padding: 24px;
  font-family: 'Open Sans', sans-serif;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #231f20;
`

export const SearchInput = styled.input`
  width: 100%;
  max-width: 360px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  outline: none;

  &:focus {
    border-color: #4f5bca;
  }

  &::placeholder {
    color: #adb5bd;
  }
`

export const PanelContainer = styled.div`
  display: flex;
  flex: 1;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  min-height: 0;
  max-height: calc(100dvh - 300px);
`

export const LeftPanel = styled.div`
  width: 260px;
  min-width: 260px;
  border-right: 1px solid #dee2e6;
  overflow-y: auto;
`

export const RightPanel = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const FeatureItem = styled.button`
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: ${({isSelected}) => (isSelected ? '#eef0fb' : 'white')};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Open Sans', sans-serif;

  &:hover {
    background: ${({isSelected}) => (isSelected ? '#eef0fb' : '#f8f9fa')};
  }
`

export const FeatureName = styled.span`
  font-size: 13px;
  font-weight: ${({isSelected}) => (isSelected ? '600' : '400')};
  color: #231f20;
  word-break: break-word;
`

export const AssignmentCount = styled.span`
  font-size: 12px;
  color: #6c757d;
  white-space: nowrap;
  margin-left: 8px;
`

export const DetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #dee2e6;
`

export const DetailTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  margin: 0;
  color: #231f20;
  word-break: break-word;
`

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd;
  font-size: 14px;
`

export const AssignmentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

export const TableHead = styled.thead`
  background: #f8f9fa;

  th {
    padding: 10px 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 1px solid #dee2e6;
  }
`

export const TableBody = styled.tbody`
  tr:not(:last-child) td {
    border-bottom: 1px solid #f0f0f0;
  }

  td {
    padding: 10px 16px;
    color: #231f20;
    vertical-align: middle;
  }
`

export const PrimaryButton = styled.button`
  background-color: #4f5bca;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  cursor: pointer;

  &:hover {
    background-color: #3d49b8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const DangerButton = styled.button`
  background: none;
  border: 1px solid #dc3545;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #dc3545;
  font-family: 'Open Sans', sans-serif;
  cursor: pointer;

  &:hover {
    background-color: #fff5f5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const SecondaryButton = styled.button`
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  cursor: pointer;

  &:hover {
    background-color: #f8f9fa;
  }
`

export const FormOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const FormCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 28px;
  width: 420px;
  max-width: 95vw;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Open Sans', sans-serif;
`

export const FormTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  color: #231f20;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FormLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #495057;
`

export const FormInput = styled.input`
  padding: 8px 12px;
  border: 1px solid ${({hasError}) => (hasError ? '#dc3545' : '#dee2e6')};
  border-radius: 6px;
  font-size: 13px;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.5;
  box-sizing: border-box;
  outline: none;
  height: 38px;
  width: 100%;

  &:focus {
    border-color: ${({hasError}) => (hasError ? '#dc3545' : '#4f5bca')};
  }

  &:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
  }
`

export const FormSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.5;
  box-sizing: border-box;
  outline: none;
  background: white;
  height: 38px;

  &:focus {
    border-color: #4f5bca;
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
`

export const ErrorMessage = styled.p`
  font-size: 12px;
  color: #dc3545;
  margin: 0;
`

export const ErrorBanner = styled.div`
  padding: 12px 16px;
  background: #fff5f5;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  color: #721c24;
  font-size: 13px;
`

export const AutocompleteWrapper = styled.div`
  position: relative;
`

export const SuggestionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow: hidden;
`

export const SuggestionItem = styled.li`
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: #231f20;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #eef0fb;
  }

  span {
    display: block;
    font-size: 11px;
    color: #6c757d;
    margin-top: 2px;
  }
`

export const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #eef0fb;
  border: 1px solid #c5c9f0;
  border-radius: 99px;
  font-size: 12px;
  color: #3d49b8;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
`

export const ChipRemoveButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  line-height: 1;
  cursor: pointer;
  color: #6c757d;
  font-size: 14px;
  display: flex;
  align-items: center;

  &:hover {
    color: #dc3545;
  }
`

export const EntityTypeToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const EntityTypeOption = styled.label`
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  cursor: pointer;
  border: 1px solid ${({isSelected}) => (isSelected ? '#4f5bca' : '#dee2e6')};
  border-radius: 6px;
  background: ${({isSelected}) => (isSelected ? '#4f5bca' : 'white')};
  color: ${({isSelected}) => (isSelected ? 'white' : '#6c757d')};
  user-select: none;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  width: 100%;
  text-align: center;

  &:hover {
    border-color: ${({isSelected}) => (isSelected ? '#3d49b8' : '#adb5bd')};
    background: ${({isSelected}) => (isSelected ? '#3d49b8' : '#f8f9fa')};
    color: ${({isSelected}) => (isSelected ? 'white' : '#495057')};
  }

  input[type='radio'] {
    display: none;
  }
`
